const isNonEmptyTextNode = (node: Node): boolean => {
  return (
    node.nodeType === node.TEXT_NODE
    && node.textContent !== null
    && node.textContent.trim() !== ''
  )
}

const isElementWithoutSlotNode = (node: Node): boolean => {
  return (
    node.nodeType === node.ELEMENT_NODE
    && !(node as HTMLElement).hasAttribute('slot')
  )
}

export const hasDefaultSlot = (element: Element): boolean => {
  return [...element.childNodes].some((node: Node): boolean => {
    return isNonEmptyTextNode(node) || isElementWithoutSlotNode(node)
  })
}

export const hasNamedSlot = (element: Element, name: string): boolean => {
  return element.querySelector(`:scope > [slot="${name}"]`) !== null
}
